import React from "react";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import UsersMain from "../../components/users/UsersMain";
import Footer from "../../components/common/Footer";
import { Box } from "@mui/material";
export default function UserPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <TitleBar />
        <NavMenu />
        <UsersMain />
      </Box>
      <Footer />
    </Box>
  );
}
